/* eslint-disable no-undef */
export const config = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT ?? '',
  OAUTH_CLIENT_ID: process.env.REACT_APP_OAUTH_USER_ID ?? '',
} as const;

export const APP_ROUTES = {
  base: '/',
  employees: {
    base: '/employees',
    current: '/employees/:id',
    creation: `/employees/add-new-employee`,
  },
  generator: {
    base: '/invoice-generator',
    employees: '/invoice-generator/employees',
    customers: '/invoice-generator/customers',
  },
  payments: {
    base: '/payments',
    details: '/payments/details',
  },
  customers: {
    base: '/customers',
    creation: '/customers/add-new-customer',
    current: '/customers/:customerId',
    techstack: '/customers/techstack',
    companies: '/customers/:slug/companies',
  },
  companies: {
    base: '/companies',
    creation: `/companies/add-new-company`,
    current: '/companies/:id',
  },
};
